import PropTypes from 'prop-types';
// @mui
import { Chip, Avatar, Checkbox, Stack, FormControlLabel } from '@mui/material';
// ---------------------------------------------------------------------------------------------------------------

BlogPostTags.propTypes = {
    post: PropTypes.object,
};
// --------------------------------------------------------------------------------------------------------------

export default function BlogPostTags({ post }) {

    const { favorite, tags, favoritePerson } = post;

    return (
        <>
            {tags?.includes(',') ?
                (
                    <Stack direction="row" flexWrap="wrap" sx={{ height: '3em' }}>
                        {tags?.split(',').map((tag) => (
                            <Chip key={tag} label={tag} sx={{ m: 0.2, height: "20px", fontSize: "8px", borderRadius: 0 }} />
                        ))}
                    </Stack>
                ) :
                <Stack direction="row" flexWrap="wrap">
                    {tags &&
                        <Chip key={tags} label={tags} sx={{ m: 0.2, height: "20px", fontSize: "8px", borderRadius: 0 }} />
                    }
                </Stack>
            }
        </>
    );
}
